import { VideoScene } from './types';

export type PreviewPayload = {
  output_format?: string;
  width?: number;
  height?: number;
  frame_rate?: number;
  elements?: Array<Record<string, any>>;
};

export function parsePreviewPayload(
  payload: PreviewPayload | null | undefined
): VideoScene[] {
  const elements = payload?.elements;
  if (!Array.isArray(elements)) return [];

  const byIndex = new Map<number, VideoScene>();

  for (const el of elements) {
    const name: string | undefined = el?.name;
    if (!name) continue;
    const match = name.match(/^Slide-(\d+)-(Image|Text)$/);
    if (!match) continue;

    const slideIdx = Number(match[1]) - 1;
    if (!Number.isFinite(slideIdx) || slideIdx < 0) continue;
    const kind = match[2];

    if (!byIndex.has(slideIdx)) {
      byIndex.set(slideIdx, {
        id: `scene-${slideIdx}`,
        index: slideIdx,
        headline: '',
        subtext: '',
        imageUrl: '',
        duration: 3,
        transition: slideIdx === 0 ? 'cut' : 'fade',
      });
    }
    const scene = byIndex.get(slideIdx)!;

    if (kind === 'Image' && el.type === 'image') {
      if (typeof el.source === 'string') scene.imageUrl = el.source;
      if (typeof el.duration === 'number') scene.duration = el.duration;
    } else if (kind === 'Text' && el.type === 'text') {
      if (typeof el.text === 'string') scene.headline = el.text;
    }
  }

  return Array.from(byIndex.values()).sort((a, b) => a.index - b.index);
}
